<ng-container *inPopulation="[populations.Kids]">
  <div class="img-banner-container d-none d-lg-block" role="banner">
    <div class="container">
      <img [src]="'banner-images/challenges-banner.png' | contentAssetImage" alt="kid banner" class="w-100" />
    </div>
  </div>
</ng-container>
<div class="d-lg-none">
  <fgb-page-header [pageTitle]="'challenges.page.title'" [backButtonLink]="'/'">
    <ng-template>
      <div class="pb-3" *inPopulation="[populations.Kids]">
        <img [src]="'banner-images/challenges-banner.png' | contentAssetImage" alt="kid banner" class="w-100 rounded" />
      </div>
    </ng-template>
  </fgb-page-header>
</div>
<div class="container pt-lg-4">
  <fgbcl-badge-achieved />
</div>

<fgbcl-scorecard-list-view
  [isSponsorInBody]="false"
  [icon]="'chevron_right'"
  [showPlaceholder]="true"
  class="bg-white"
></fgbcl-scorecard-list-view>
